import ImageOne from "../images/house-1.jpg";
import ImageTwo from "../images/house-2.jpg";
import ImageThree from "../images/house-3.jpg";
import ImageFour from "../images/house-4.jpg";

export const SliderData = [
  {
    title: "Luxury Villa in Bail, Indonesia",
    price: "$4,280,000",
    path: "/homes",
    label: "View Home",
    image: ImageOne,
    alt: "House",
  },
  {
    title: "Houses in San Jose, Costa Rica",
    price: "$2,860,000",
    path: "/homes",
    label: "View Home",
    image: ImageTwo,
    alt: "House",
  },
  {
    title: "Houses in Calabasas, California",
    price: "$8,420,000",
    path: "/homes",
    label: "View Home",
    image: ImageThree,
    alt: "House",
  },
  {
    title: "Houses in Houston, Texas",
    price: "$6,660,000",
    path: "/homes",
    label: "View Home",
    image: ImageFour,
    alt: "House",
  },
];
